import React from 'react';
import {ChevronLeftIcon, Pressable, HStack, Text} from 'native-base';
import {ITemplateUsage} from '../../interfaces/ui';
import {message} from './../../utils/messages';

interface Props {
  label?: string;
  onPress: () => void;
  usage?: ITemplateUsage;
  mt?: string;
}

const GoBackButton = (props: Props) => {
  const {label, onPress, usage, mt} = props;

  const internalUsage = 'internal';

  const externalColor = {
    icon: '#0089ff',
    label: '#FFFFFF',
  };

  const internalColor = {
    icon: '#0089ff',
    label: '#05375a',
  };

  const handleOnPress = () => {
    if (onPress) {
      onPress();
    }
  };

  const getColorIcon = () => {
    if (usage === internalUsage) {
      return internalColor.icon;
    }
    return externalColor.icon;
  };

  const getColorLabel = () => {
    if (usage === internalUsage) {
      return internalColor.label;
    }
    return externalColor.label;
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        height="10"
        mt={mt}
        width="50%"
        alignItems="center"
        justifyContent="flex-start"
        marginX="5">
        <ChevronLeftIcon color={getColorIcon()} />
        <Text color={getColorLabel()} fontWeight="bold">
          {message(
            label && label.trim() !== '' ? label : 'template-internal-go-back',
          )}
        </Text>
      </HStack>
    </Pressable>
  );
};

export default GoBackButton;
